import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import PropTypes from 'prop-types';
import ErrorBoundary from '../../ErrorBoundary';

import Form from './Form';
import { Modal, Icon } from 'antd';

/**
 * @component
 * @category Form Page
 * @subcategory Form Modal
 * @name FormContainerModal
 * @description It's the main form page
 * <br> <br>
 * **Example**
 * ```js
 *   <FormContainerModal />
 * ```
 */
class FormContainerModal extends Component {
  state = {};

  componentWillMount = () => {
    const { isFormSubmitSuccess } = this.props;
    const { user, verification } = this.props.initAuth;
    // check if user exist then make GET request to get the initial pickup/delivery json
    if (!isFormSubmitSuccess && user && verification) {
      //make GET request
      this.props.getFormInitPickupDeliveryData();
    }
  };

  closeModal = () => {};

  handleGoBack = () => {
    //window.history.back();
    window.location.href = "https://portal.primefreight.com/dashboard";
  };

  render() {
    const { showForm, showBackBtn, isFormSubmitSuccess } = this.props;

    return (
      <>
        <Modal
         mask={false}
          title={
            <div>
             {
                  showBackBtn &&
                  <div style={{paddingBottom:"10px"}}>
                      <button className="back-btn" onClick={this.handleGoBack}>
                       <Icon type="arrow-left" style={{marginRight:"10px"}}/>
                        Back to Portal
                      </button>
                  </div>
              }
              <div
                style={{
                  fontSize: '23px',
                  lineHeight: '23px',
                  color: '#373848',
                }}
              >
                Smooth shipping on the online freight marketplace
              </div>
              <p
                style={{
                  fontSize: '13px',
                  lineHeight: '22px',
                  color: '#373848',
                }}
              >
                Transparent pricing. Instant quote comparisons. 24/7 .
              </p>
            </div>
          }
          destroyOnClose={true}
          footer={null}
          centered
          maskClosable={false}
          // disable cancel functionality if form has not been made success once before
          onCancel={!!isFormSubmitSuccess ? this.props.closeModal : null}
          // remove close 'X' icon if form has not been made success once before
          closable={!!isFormSubmitSuccess}
          visible={showForm}
          width={"100%"}
          // disable Esc key click if form has not been made success once before
          keyboard={!!isFormSubmitSuccess}
        >
          <ErrorBoundary>
            <div className="testR1">
              <Form />
            </div>
          </ErrorBoundary>
        </Modal>
      </>
    );
  }
}

FormContainerModal.propTypes = {
  /**
   *  Whether to show Form modal i.e Form page
   */
  showForm: PropTypes.bool,
  /**
   * Whether Form is successfully submitted for first time.
   */
  isFormSubmitSuccess: PropTypes.bool,
  /**
   * initial authentication info
   */
  initAuth: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    showForm: state.form.showForm,
    isFormSubmitSuccess: state.form.isFormSubmitSuccess,
    showBackBtn: state.route.showBackBtn,
    initAuth: state.code_config.initAuth,
  };
};

export default connect(mapStateToProps, actions)(FormContainerModal);
